import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography, IconButton} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FieldView from 'core/components/layout/FieldView';
import {setPartySorting} from 'store/slice/PharmaSlice';

export default function PartyListTableHeader(){
    const dispatch = useDispatch();
    const {sorting} = useSelector((state) => state.pharmaslice.partyDashboard);
    
    const handleColumnClick = (column) => {
        const currentSorting = sorting.column === column ? !sorting.asc : true;
        dispatch(setPartySorting({ column, asc: currentSorting }));     
    }

    const getSortIcon = (column) => {
        if (sorting.column === column) {
            return sorting.asc ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />;
        }
        return null;
    }

    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={6} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography 
                                variant="h5" 
                                sx={{cursor:'pointer', display: 'flex', alignItems: 'center'}} 
                                onClick={()=>handleColumnClick('title')}
                            > 
                                Party Name {getSortIcon('title')}
                            </Typography>
                        </Grid>
                        <Grid item lg={2} xs={4} ><Typography variant="h5"> Status </Typography></Grid>
                    {/*    
                        <Grid item lg={2} xs={1} ><Typography variant="h5"> Contact </Typography></Grid>
                        <Grid item lg={2} xs={1} ><Typography variant="h5"> Contact Mobile </Typography></Grid>
                        <Grid item lg={2} xs={1} ><Typography variant="h5"> Drug License </Typography></Grid>
                        <Grid item lg={2} xs={1} ><Typography variant="h5"> GST </Typography></Grid>
                        
                        <Grid item lg={2} xs={1} ><Typography variant="h5"> Address </Typography></Grid>
                        <Grid item lg={2} xs={1} ><Typography variant="h5"> Corporate Email </Typography></Grid>
                    */}

      </Grid>
      
    )
}